
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/interactive-videos",
      function () {
        return require("private-next-pages/interactive-videos/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/interactive-videos"])
      });
    }
  